import {createSlice} from '@reduxjs/toolkit';

const progressing_slice = createSlice({
    name: 'progressing_status',
    initialState: {
        progressing : false
    },
    reducers: {
        progressing_status : (state , {payload}) => {
            state.progressing = payload;
        }
    }
});


export const {progressing_status} = progressing_slice.actions;
export default progressing_slice.reducer;



// note
/*

useEffect(()=>{
    dispatch(progressing_status(isLoading))
},[isLoading])


* There are two type of loader. one is called when the hole page reload, another is called when the pages will change.
* When we change the pages we can see a progress bar on top.
* "isLoading" comes from useHTTP hook. It return true/false according to the API response.
* We are handeling top progress bar with "progressing_status". Distach "isLoading" on "progressing_status" like the given example.
* Some of page, progress does not depend on API response. We manually handeling this by "setTImeOut" 
* Preloader.js


*/
